import markdownit from "markdown-it";

const md = markdownit();

export function markdown(input: string): string {
  return md.render(input);
}
